<template>
	<UITopHeading>Impressum</UITopHeading>
	<div class="container flex flex-col">
		<SharedTheImpressum />
	</div>
</template>

<script setup lang="ts">
useSeoMeta({
	title: 'Impressum',
	ogTitle: 'Impressum',
	twitterTitle: 'Impressum',
	description: 'Das offizielle Impressum des Propellerfestivals.',
	ogDescription: 'Das offizielle Impressum des Propellerfestivals.',
	twitterDescription: 'Das offizielle Impressum des Propellerfestivals.',
	ogUrl: 'https://propellerfestival.de/impressum',
})
</script>
